import { NewsQueryTime } from "@/graphql";
import type { Router } from "@/typeDefinitions/custom/Router";

const router: Router.LicensedRouterExportType = [
  {
    path: "/newsTab/:id",
    redirect: (route) => ({
      name: "NewsTabs",
      params: { id: route.params.id },
      query: route.query,
      hash: route.hash,
    }),
  },
  {
    path: "/news",
    name: "News",
    redirect: { name: "Slider" },
    children: [
      {
        path: "slider",
        name: "Slider",
        redirect: { name: "SliderList" },
        children: [
          {
            path: "list",
            name: "SliderList",
            component: () => import("@/modules/news/views/SliderList.vue"),
          },
          {
            path: "infinity/:id",
            name: "SliderInfinity",
            component: () => import("@/modules/news/views/SliderInfinity.vue"),
            meta: { hideNavbar: true },
            props: (route) => {
              return {
                id:
                  route.params.id && Number.isSafeInteger(Number(route.params.id))
                    ? Number(route.params.id)
                    : undefined,
              };
            },
          },
          {
            path: "upsert/:id?",
            name: "SliderUpsert",
            component: () => import("@/modules/news/views/SliderUpsert.vue"),
            props: (route) => {
              return {
                id: route.params.id ? Number(route.params.id) : undefined,
              };
            },
          },
        ],
      },
      {
        path: "n",
        name: "NewsNews",
        redirect: { name: "NewsTabs" },
        children: [
          {
            path: "newsTab/:id",
            name: "NewsTabs",
            component: () => import("@/modules/news/views/NewsTabs.vue"),
            meta: {
              rights: ["news.admin"],
            },
            props: (route) => {
              switch (route.params.id) {
                case "newsPlanned":
                  return { queryTime: NewsQueryTime.FUTURE };
                case "newsArchiv":
                  return { queryTime: NewsQueryTime.PAST };
                case "newsActive":
                default:
                  return { queryTime: NewsQueryTime.CURRENT };
              }
            },
          },
          {
            path: "new",
            name: "CreateNews",
            component: () => import("./views/CreateNews.vue"),
            meta: {
              rights: ["news.admin"],
            },
          },
          {
            path: "edit/:id",
            name: "EditNews",
            component: () => import("./views/UpdateNews.vue"),
            meta: {
              rights: ["news.admin"],
              authorizationSiteResource: "news",
              authorizationSiteResourceIsMultiSite: true,
            },
            props: (route) => ({ newsId: Number(route.params.id) }),
          },
        ],
      },
      {
        path: "settings",
        name: "NewsSettings",
        component: () => import("@/modules/news/views/NewsSettings.vue"),
      },
      {
        path: "new",
        redirect: { name: "CreateNews" },
      },
      {
        path: "edit/:id",
        redirect: (route) => ({
          name: "EditNews",
          params: { id: route.params.id },
          query: route.query,
          hash: route.hash,
        }),
      },
    ],
  },
];

export default router;
